import React, { useState } from "react";
import "../../styles/AiReferenceStyles/TranslationDropdown.css";

function TranslationDropdown() {
  const [showDropdown, setShowDropdown] = useState(false);

  const selectLanguage = (lang) => {
    const currentLang = sessionStorage.getItem("preferred-language");

    if (currentLang === lang) {
      setShowDropdown(false);
      return;
    }

    sessionStorage.setItem("preferred-language", lang);
    window.location.reload();
  };

  return (
    <div className="translation-icon-container">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="translation-icon-btn d-flex align-items-center justify-content-center"
      >
        <svg
          width="40"
          height="36"
          viewBox="0 0 40 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.825 35.5L27.7875 14.5H31.4625L39.425 35.5H35.75L33.8687 30.1625H25.3812L23.5 35.5H19.825ZM6 30.25L3.55 27.8L12.3875 18.9625C11.3667 17.9417 10.4403 16.775 9.6085 15.4625C8.77667 14.15 8.01133 12.6625 7.3125 11H10.9875C11.5708 12.1375 12.1542 13.1292 12.7375 13.975C13.3208 14.8208 14.0208 15.6667 14.8375 16.5125C15.8 15.55 16.7992 14.2007 17.8352 12.4648C18.8712 10.7288 19.6512 9.07383 20.175 7.5H0.75V4H13V0.5H16.5V4H28.75V7.5H23.675C23.0625 9.6 22.1437 11.7583 20.9187 13.975C19.6937 16.1917 18.4833 17.8833 17.2875 19.05L21.4875 23.3375L20.175 26.925L14.8375 21.4563L6 30.25ZM26.475 27.1H32.775L29.625 18.175L26.475 27.1Z"
            fill="white"
          />
        </svg>
      </button>
      {showDropdown && (
        <div className="translation-dropdown">
          <div
            onClick={() => selectLanguage("English")}
            className="dropdown-item"
          >
            <svg
              width="121"
              height="86"
              viewBox="0 0 121 86"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 0H120.12V85.8H0V0Z"
                fill="url(#paint0_linear_6066_3190)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 0H120.12V5.72H0V0ZM0 11.44H120.12V17.16H0V11.44ZM0 22.88H120.12V28.6H0V22.88ZM0 34.32H120.12V40.04H0V34.32ZM0 45.76H120.12V51.48H0V45.76ZM0 57.2H120.12V62.92H0V57.2ZM0 68.64H120.12V74.36H0V68.64ZM0 80.08H120.12V85.8H0V80.08Z"
                fill="url(#paint1_linear_6066_3190)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 0H51.48V40.04H0V0Z"
                fill="url(#paint2_linear_6066_3190)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.57875 11.44C6.99922 11.44 5.71875 10.1595 5.71875 8.57997C5.71875 7.00044 6.99922 5.71997 8.57875 5.71997C10.1583 5.71997 11.4388 7.00044 11.4388 8.57997C11.4388 10.1595 10.1583 11.44 8.57875 11.44ZM20.0188 11.44C18.4392 11.44 17.1588 10.1595 17.1588 8.57997C17.1588 7.00044 18.4392 5.71997 20.0188 5.71997C21.5983 5.71997 22.8788 7.00044 22.8788 8.57997C22.8788 10.1595 21.5983 11.44 20.0188 11.44ZM31.4588 11.44C29.8792 11.44 28.5988 10.1595 28.5988 8.57997C28.5988 7.00044 29.8792 5.71997 31.4588 5.71997C33.0383 5.71997 34.3188 7.00044 34.3188 8.57997C34.3188 10.1595 33.0383 11.44 31.4588 11.44ZM42.8988 11.44C41.3192 11.44 40.0388 10.1595 40.0388 8.57997C40.0388 7.00044 41.3192 5.71997 42.8988 5.71997C44.4783 5.71997 45.7588 7.00044 45.7588 8.57997C45.7588 10.1595 44.4783 11.44 42.8988 11.44ZM14.2988 17.16C12.7192 17.16 11.4388 15.8795 11.4388 14.3C11.4388 12.7204 12.7192 11.44 14.2988 11.44C15.8783 11.44 17.1588 12.7204 17.1588 14.3C17.1588 15.8795 15.8783 17.16 14.2988 17.16ZM25.7388 17.16C24.1592 17.16 22.8788 15.8795 22.8788 14.3C22.8788 12.7204 24.1592 11.44 25.7388 11.44C27.3183 11.44 28.5988 12.7204 28.5988 14.3C28.5988 15.8795 27.3183 17.16 25.7388 17.16ZM37.1788 17.16C35.5992 17.16 34.3188 15.8795 34.3188 14.3C34.3188 12.7204 35.5992 11.44 37.1788 11.44C38.7583 11.44 40.0388 12.7204 40.0388 14.3C40.0388 15.8795 38.7583 17.16 37.1788 17.16ZM42.8988 22.88C41.3192 22.88 40.0388 21.5995 40.0388 20.02C40.0388 18.4404 41.3192 17.16 42.8988 17.16C44.4783 17.16 45.7588 18.4404 45.7588 20.02C45.7588 21.5995 44.4783 22.88 42.8988 22.88ZM31.4588 22.88C29.8792 22.88 28.5988 21.5995 28.5988 20.02C28.5988 18.4404 29.8792 17.16 31.4588 17.16C33.0383 17.16 34.3188 18.4404 34.3188 20.02C34.3188 21.5995 33.0383 22.88 31.4588 22.88ZM20.0188 22.88C18.4392 22.88 17.1588 21.5995 17.1588 20.02C17.1588 18.4404 18.4392 17.16 20.0188 17.16C21.5983 17.16 22.8788 18.4404 22.8788 20.02C22.8788 21.5995 21.5983 22.88 20.0188 22.88ZM8.57875 22.88C6.99922 22.88 5.71875 21.5995 5.71875 20.02C5.71875 18.4404 6.99922 17.16 8.57875 17.16C10.1583 17.16 11.4388 18.4404 11.4388 20.02C11.4388 21.5995 10.1583 22.88 8.57875 22.88ZM14.2988 28.6C12.7192 28.6 11.4388 27.3195 11.4388 25.74C11.4388 24.1604 12.7192 22.88 14.2988 22.88C15.8783 22.88 17.1588 24.1604 17.1588 25.74C17.1588 27.3195 15.8783 28.6 14.2988 28.6ZM25.7388 28.6C24.1592 28.6 22.8788 27.3195 22.8788 25.74C22.8788 24.1604 24.1592 22.88 25.7388 22.88C27.3183 22.88 28.5988 24.1604 28.5988 25.74C28.5988 27.3195 27.3183 28.6 25.7388 28.6ZM37.1788 28.6C35.5992 28.6 34.3188 27.3195 34.3188 25.74C34.3188 24.1604 35.5992 22.88 37.1788 22.88C38.7583 22.88 40.0388 24.1604 40.0388 25.74C40.0388 27.3195 38.7583 28.6 37.1788 28.6ZM42.8988 34.32C41.3192 34.32 40.0388 33.0395 40.0388 31.46C40.0388 29.8804 41.3192 28.6 42.8988 28.6C44.4783 28.6 45.7588 29.8804 45.7588 31.46C45.7588 33.0395 44.4783 34.32 42.8988 34.32ZM31.4588 34.32C29.8792 34.32 28.5988 33.0395 28.5988 31.46C28.5988 29.8804 29.8792 28.6 31.4588 28.6C33.0383 28.6 34.3188 29.8804 34.3188 31.46C34.3188 33.0395 33.0383 34.32 31.4588 34.32ZM20.0188 34.32C18.4392 34.32 17.1588 33.0395 17.1588 31.46C17.1588 29.8804 18.4392 28.6 20.0188 28.6C21.5983 28.6 22.8788 29.8804 22.8788 31.46C22.8788 33.0395 21.5983 34.32 20.0188 34.32ZM8.57875 34.32C6.99922 34.32 5.71875 33.0395 5.71875 31.46C5.71875 29.8804 6.99922 28.6 8.57875 28.6C10.1583 28.6 11.4388 29.8804 11.4388 31.46C11.4388 33.0395 10.1583 34.32 8.57875 34.32Z"
                fill="url(#paint3_linear_6066_3190)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_6066_3190"
                  x1="1261.26"
                  y1="0"
                  x2="1261.26"
                  y2="1287"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="1" stop-color="#F0F0F0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_6066_3190"
                  x1="1261.26"
                  y1="0"
                  x2="1261.26"
                  y2="1287"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#D02F44" />
                  <stop offset="1" stop-color="#B12537" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_6066_3190"
                  x1="540.54"
                  y1="0"
                  x2="540.54"
                  y2="600.6"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#46467F" />
                  <stop offset="1" stop-color="#3C3C6D" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_6066_3190"
                  x1="426.139"
                  y1="5.71997"
                  x2="426.139"
                  y2="434.72"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="1" stop-color="#F0F0F0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div
            onClick={() => selectLanguage("Japanese")}
            className="dropdown-item"
          >
            <svg
              width="121"
              height="86"
              viewBox="0 0 121 86"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 0H120.12V85.8H0V0Z"
                fill="url(#paint0_linear_6066_3205)"
              />
              <path
                d="M60.0603 68.64C74.2761 68.64 85.8003 57.1158 85.8003 42.9C85.8003 28.6842 74.2761 17.16 60.0603 17.16C45.8445 17.16 34.3203 28.6842 34.3203 42.9C34.3203 57.1158 45.8445 68.64 60.0603 68.64Z"
                fill="url(#paint1_linear_6066_3205)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_6066_3205"
                  x1="1261.26"
                  y1="0"
                  x2="1261.26"
                  y2="1287"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="1" stop-color="#F0F0F0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_6066_3205"
                  x1="574.86"
                  y1="17.16"
                  x2="574.86"
                  y2="789.36"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#D81441" />
                  <stop offset="1" stop-color="#BB0831" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      )}
    </div>
  );
}

export default TranslationDropdown;
